export const processingSpeedDefaultDifficultyLevels = [
    {
        numberOfOptions: 4,
        contrastPercent: 100,
        noisePercent: 0,
        deadlineMultiplier: 2.5,
        hasFlankers: false,
        incongruentPercent: 0,
    },
    {
        numberOfOptions: 5,
        contrastPercent: 100,
        noisePercent: 0,
        deadlineMultiplier: 2.0,
        hasFlankers: false,
        incongruentPercent: 0,
    },
    {
        numberOfOptions: 6,
        contrastPercent: 90,
        noisePercent: 5,
        deadlineMultiplier: 1.75,
        hasFlankers: true,
        incongruentPercent: 20,
    },
    {
        numberOfOptions: 8,
        contrastPercent: 75,
        noisePercent: 15,
        deadlineMultiplier: 1.5,
        hasFlankers: true,
        incongruentPercent: 35,
    },
    {
        numberOfOptions: 10,
        contrastPercent: 60,
        noisePercent: 22,
        deadlineMultiplier: 1.25,
        hasFlankers: true,
        incongruentPercent: 45,
    },
    {
        numberOfOptions: 12,
        contrastPercent: 50,
        noisePercent: 28,
        deadlineMultiplier: 1.1,
        hasFlankers: true,
        incongruentPercent: 50,
    },
    {
        numberOfOptions: 14,
        contrastPercent: 40,
        noisePercent: 35,
        deadlineMultiplier: 1.0,
        hasFlankers: true,
        incongruentPercent: 55,
    },
];

export const processingSpeedDefaultAssessmentDifficultyLevel = processingSpeedDefaultDifficultyLevels[3];

export const processingSpeedDefaultAssessmentSymbols: string[] = [
    '▲',
    '●',
    '■',
    '◆',
    '★',
    '♠',
    '♣',
    '♥',
    '♦',
    '▼',
    '◀',
    '▶',
    '○',
    '□',
];

export const processingSpeedDefaultTrainingSymbols: string[] = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];

export const processingSpeedDefaultTrialsPerBlock = 15;
export const processingSpeedDefaultNumberOfBlocks = 3;
export const processingSpeedDefaultNumberOfPracticeQuestions = 5;
export const processingSpeedDefaultFeedbackDurationMs = 450;
export const processingSpeedDefaultBaselineRTMinMs = 600;
export const processingSpeedDefaultBaselineRTMaxMs = 2500;

export const processingSpeedDefaultInstructions =
    '1. A symbol will appear in the center of the screen.\n2. Find and click the matching symbol from the options below.\n3. Respond as quickly and accurately as possible before time runs out.';

export const processingSpeedDefaultMobileInstructions =
    '1. A symbol will appear in the center of the screen.\n2. Find and tap the matching symbol from the options below.\n3. Respond as quickly and accurately as possible before time runs out.';

export const processingSpeedTrainingDefaultInstructions =
    '1. A symbol will appear in the center of the screen.\n2. Find and click the matching symbol from the options below.\n3. Respond as quickly and accurately as possible before time runs out.\n4. The difficulty will adapt based on your performance.';

export const processingSpeedTrainingDefaultMobileInstructions =
    '1. A symbol will appear in the center of the screen.\n2. Find and tap the matching symbol from the options below.\n3. Respond as quickly and accurately as possible before time runs out.\n4. The difficulty will adapt based on your performance.';

export const processingSpeedTrainingDefaultAdaptiveDifficulty = {
    startingDifficultyLevel: 3,
    consecutiveCorrectToIncrease: 4,
    consecutiveIncorrectToDecrease: 3,
    accuracyThresholdToIncrease: 0.8,
    accuracyThresholdToDecrease: 0.5,
};

export const processingSpeedName = 'Processing Speed';
export const processingSpeedDescription =
    'Measures speed and accuracy of processing by identifying and matching visual symbols under time pressure.';
export const processingSpeedTrainingDescription =
    'Develops processing speed and accuracy by practising the identification and matching of visual symbols under time pressure.';
